import { cn } from '@change/ds-utils';

import { type Platform, PLATFORM_CONFIG } from '../../../shared/constants';

export const PlatformIcon = (Props: Props) => {
	const { platform } = Props;
	const { Icon, bgColor, bgGradient, iconColor, brandLabel } = PLATFORM_CONFIG[platform];

	return (
		<div
			className={cn(
				'absolute -top-2 -right-2 flex h-8 w-8 items-center justify-center rounded-full border border-solid border-white shadow-lg',
				bgGradient,
			)}
			sx={{
				zIndex: 1,
			}}
			style={!bgGradient ? { backgroundColor: bgColor } : undefined}
			data-testid={`${platform}-badge`}
			role="img"
			aria-label={`${brandLabel} platform`}
		>
			<Icon className={iconColor} size={20} aria-hidden="true" />
		</div>
	);
};

type Props = Readonly<{
	platform: Platform;
}>;
